import ContentHeader from './content-header';

export default ContentHeader;
